export enum GroupSettingsTabs {
  General = 'general',
  Modules = 'modules',
  Rules = 'rules',
}
